import SpotifyApiService from '../services/SpotifyApiService';
import type { CuratorOfferSubmissionPlaylist } from './curatorOffer';

const getSpotifyUsername = (): string => {
  try {
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    return String(spotifyUser?.username || spotifyUser?.display_name || '').trim();
  } catch {
    return '';
  }
};

/**
 * Fetch Spotify playlists the current user fully controls (owned),
 * matching Songplace Curator "My playlists" filter.
 */
export const fetchOwnedPlaylists = async (): Promise<CuratorOfferSubmissionPlaylist[]> => {
  const username = getSpotifyUsername();
  const owned: CuratorOfferSubmissionPlaylist[] = [];
  let offset = 0;
  const limit = 50;
  let total = Infinity;

  while (offset < total) {
    const response = await SpotifyApiService.getInstance().getUserPlaylists(limit, offset);
    const items = response?.data?.items || [];
    total = Number(response?.data?.total ?? items.length);
    offset += items.length;

    for (const item of items) {
      const ownerName = String(item?.owner?.display_name || '').trim();
      if (username && ownerName !== username) continue;

      const playlistId = String(item?.id || '').trim();
      if (!playlistId) continue;

      owned.push({
        playlistId,
        name: String(item?.name || 'Untitled playlist'),
        imageUrl: String(item?.images?.[0]?.url || ''),
        externalUrl: String(item?.external_urls?.spotify || ''),
      });
    }

    if (!items.length) break;
  }

  const seen = new Set<string>();
  return owned.filter(p => {
    if (seen.has(p.playlistId)) return false;
    seen.add(p.playlistId);
    return true;
  });
};
